var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2745 14.3856C11.5723 14.2249 11.758 13.9194 11.758 13.5871V8.41291H21.9745C22.4904 8.41291 22.9091 8.00394 22.9091 7.50003C22.9091 6.99612 22.4904 6.58715 21.9745 6.58715H11.758V1.41295C11.758 1.07944 11.5723 0.773929 11.2745 0.614479C10.9767 0.452595 10.6128 0.46355 10.325 0.64004L0.436126 6.72713C0.164482 6.8951 0 7.186 0 7.50003C0 7.81406 0.164482 8.10497 0.436126 8.27294L10.325 14.36C10.477 14.4525 10.6502 14.5 10.8234 14.5C10.9779 14.5 11.1337 14.4611 11.2745 14.3856Z",
    fill: "#062880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.7adac4fbbdc20fc1567ade4bdf1acb9d.svg";
export { ForwardRef as ReactComponent };